import { IClaim } from './IClaim';

export interface Identity {
  accessToken: string;
  refreshToken: string;
  expires: number;
  role: string;
  claims: IClaim;
}
